import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import DefaultButton from "../../../components/widgets/default-button";
import { StoreState } from "@type/models/store";
import { AutoComplete } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  FetchAndDispatchActions,
  TrackDispatchAndActions,
} from "../dispatch-files/fetch-dispatch";
import {
  getComposerOptions,
  getConductorOptions,
  getCopyrightPOptionsFromApi,
  getFeatureOptionsFromApi,
  getLableNameOptionsFromApi,
  getLicensorOPtionsFromApi,
  getOrchestraChoirOptions,
  getPrimaryArtistsOptionsFromApi,
  getReleaseTitleOptions,
  getSingerOptions,
  getTrackTitleOptions,
} from "../../../hooks/useOverlay";
import "../../../assets/scss/components/modal.scss";
type OptionType = {
  value: string;
  label: string;
};

export const TrackOverlayModal: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const {
    show,
    mkey,
    closeModal,
    openSecondModal,
    setFormData,
    setLoading,
    setData,
    data,
    setAbortController,
    selectedRelease,
    setSelectedRelease,
    selectedTrackTitle,
    setSelectedTrackTitle,
  } = props;
  const { release_title, track_title } = useSelector(
    (state: StoreState) => state.suggestion
  );
  const [releaseOptions, setReleaseOptions] = useState<any>([]);
  const [trackTitleOptions, setTrackTitleOptions] = useState<any>([]);

  const handleInputChange = (name: string, value: string) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const getPayload = () => {
    const payload: any = {};
    for (const key in data) {
      if (data[key]?.value) {
        payload[key] = [data[key]?.value];
      } else {
        payload[key] = data[key];
      }
    }
    return payload;
  };

  const handleContinueClick = async () => {
    setLoading(true);
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    data.page = 1;
    data.pageSize = 10;
    setFormData(data);
    closeModal();
    openSecondModal();
    const payload = getPayload();
    let datafetch: any = await TrackDispatchAndActions(
      dispatch,
      payload,
      newAbortController.signal
    );
    if (datafetch) setLoading(false);
    dispatch({
      type: "SET_SELECT_TRACKS",
      payload: [],
    });
  };

  const handleDiscard = () => {
    closeModal();
    setData({});
    setSelectedRelease("");
    setSelectedTrackTitle("");
  };

  useEffect(() => {
    setLoading(true);
    FetchAndDispatchActions(dispatch)
      .then((result) => {
        console.log(result);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
    setReleaseOptions(data.release_title);
    setTrackTitleOptions(data.track_title);
  }, []);

  function debounce(func: Function, delay: number) {
    let timeoutId: NodeJS.Timeout;
    return function debounced(...args: any[]) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  return (
    <>
      <Modal
        show={show}
        key={"modal_" + mkey}
        size="xl" //'sm' | 'lg' | 'xl'
        backdrop="static"
        onHide={closeModal}
        centered
        className="custom-modal track-overlay-modal"
      >
        <Modal.Header className="track-header-wrapper relative">
          <Modal.Title className="title-wrapper">
            Choose Track Info Overlay
          </Modal.Title>

          <div className="absolute top-1/2 right-0 transform -translate-y-1/2  cursor-pointer z-2 title-wrapper">
            <CloseOutlined onClick={handleDiscard} />
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="flex justify-content-between items-center tw-gap-[5px] tw-my-[20px] tw-flex-wrap">
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Release Title</label>
              <AutoComplete
                className="auto-select  bg-[#DDE9F4] rounded-[5px] text-[#7EB8CC]"
                style={{ width: "100%" }}
                onChange={async (
                  value: string,
                  option: OptionType | OptionType[]
                ) => {
                  const inputValue =
                    typeof value === "number"
                      ? Array.isArray(option)
                        ? option[0].label
                        : option.label
                      : value;
                  setSelectedRelease(inputValue);
                  setData({ ...data, release: option });
                  try {
                    const options: any[] = await getReleaseTitleOptions(
                      inputValue,
                      release_title
                    );
                    if (Array.isArray(options) && options.length > 0) {
                      setReleaseOptions(options);
                    } else {
                      setReleaseOptions([]);
                    }
                  } catch (error) {
                    console.error(
                      "Error fetching release title options:",
                      error
                    );
                    setReleaseOptions([]);
                  }
                }}
                options={releaseOptions}
                placeholder="Please enter release title"
                value={selectedRelease}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Composer</label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getComposerOptions, 500)}
                placeholder="Please enter composer"
                isMulti={false}
                value={data.composer}
                onChange={(item) => setData({ ...data, composer: item })}
                isSearchable={true}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title"> ℗ </label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getCopyrightPOptionsFromApi, 500)}
                placeholder="Please enter copyright"
                isMulti={false}
                value={data.copyRightP}
                onChange={(item) => setData({ ...data, copyRightP: item })}
                isSearchable={true}
              />
            </div>
          </div>

          <div className="flex justify-content-between items-center tw-gap-[5px] tw-my-[20px] tw-flex-wrap">
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Release Version</label>
              <input
                type="text"
                onChange={(e) =>
                  handleInputChange("release_version", e.target.value)
                }
                placeholder="Please enter text"
                className={"input-search"}
                value={data.release_version}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Singer</label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getSingerOptions, 500)}
                placeholder="Please enter singer"
                isMulti={false}
                value={data.singer}
                onChange={(item) => setData({ ...data, singer: item })}
                isSearchable={true}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title"> ℗ Year </label>
              <input
                type="number"
                value={data.copyRightYear}
                onChange={(e) =>
                  handleInputChange("copyRightYear", e.target.value)
                }
                placeholder="Please enter number"
                className={"input-search"}
              />
            </div>
          </div>
          <div className="flex justify-content-between items-center tw-gap-[5px] tw-my-[20px] tw-flex-wrap">
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Track Title</label>
              <AutoComplete
                className="auto-select bg-[#DDE9F4] rounded-[5px] text-[#7EB8CC]"
                style={{ width: "100%" }}
                onChange={async (value, option: OptionType | OptionType[]) => {
                  const inputValue =
                    typeof value === "number"
                      ? Array.isArray(option)
                        ? option[0].label
                        : option.label
                      : value;
                  setSelectedTrackTitle(inputValue);
                  setData({ ...data, track_title: option });

                  const options: any[] = await getTrackTitleOptions(
                    inputValue,
                    track_title
                  );
                  setTrackTitleOptions(options);
                }}
                options={trackTitleOptions}
                placeholder="Please enter track title"
                value={selectedTrackTitle}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Conductor</label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getConductorOptions, 500)}
                placeholder="Please enter conductor"
                isMulti={false}
                value={data.conductor}
                onChange={(item) => setData({ ...data, conductor: item })}
                isSearchable={true}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title"> Licensor </label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getLicensorOPtionsFromApi, 500)}
                placeholder="Please enter licensor"
                isMulti={false}
                value={data.licensor}
                onChange={(item) => setData({ ...data, licensor: item })}
                isSearchable={true}
              />
            </div>
          </div>
          <div className="flex justify-content-between items-center tw-gap-[5px] tw-my-[20px] tw-flex-wrap">
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Label</label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getLableNameOptionsFromApi, 500)}
                placeholder="Please enter label name"
                isMulti={false}
                value={data.label}
                onChange={(item) => setData({ ...data, label: item })}
                isSearchable={true}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Orchestra / Choir</label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getOrchestraChoirOptions, 500)}
                placeholder="Please enter orchestra choir"
                isMulti={false}
                value={data.orchestra}
                onChange={(item: any) => setData({ ...data, orchestra: item })}
                isSearchable={true}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Series</label>
              <input
                type="text"
                value={data.series}
                onChange={(e) => handleInputChange("series", e.target.value)}
                placeholder="Please enter a text"
                className={"input-search"}
              />
            </div>
          </div>
          <div className="flex justify-content-between items-center tw-gap-[5px] tw-my-[20px] tw-flex-wrap">
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Primary Artist</label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getPrimaryArtistsOptionsFromApi, 500)}
                placeholder="Please enter primary artist"
                isMulti={false}
                value={data.primaryArtist}
                onChange={(item: any) =>
                  setData({ ...data, primaryArtist: item })
                }
                isSearchable={true}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Featuring</label>
              <AsyncSelect
                className={"select-search basic-single"}
                classNamePrefix="select"
                loadOptions={debounce(getFeatureOptionsFromApi, 500)}
                placeholder="Please enter feature name"
                isMulti={false}
                value={data.featuring}
                onChange={(item: any) => setData({ ...data, featuring: item })}
                isSearchable={true}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Source CD</label>
              <input
                type="text"
                value={data.source_CD}
                onChange={(e) => handleInputChange("source_CD", e.target.value)}
                placeholder="Please enter a text"
                className={"input-search"}
              />
            </div>
          </div>
          <div className="flex justify-content-between items-center tw-gap-[5px] tw-my-[20px] tw-flex-wrap">
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title"> Track Part</label>
              <input
                type="text"
                value={data.track_part}
                onChange={(e) =>
                  handleInputChange("track_part", e.target.value)
                }
                placeholder="Please enter text"
                className={"input-search"}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">ISRC</label>
              <input
                type="text"
                value={data.isrc}
                onChange={(e) => handleInputChange("isrc", e.target.value)}
                placeholder="Please enter a text"
                className={"input-search"}
              />
            </div>
            <div className="fields-wrapper flex-grow-shrink tw-min-w-[30%] tw-max-w-[30%]">
              <label className="label-title">Source</label>
              <input
                type="text"
                value={data.source}
                onChange={(e) => handleInputChange("source", e.target.value)}
                placeholder="Please enter a text"
                className={"input-search"}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <DefaultButton
            textColor="var(--color-primary)"
            color="white"
            borderColor="var(--color-primary)"
            onClick={handleDiscard}
          >
            Discard
          </DefaultButton>
          <DefaultButton
            type="submit"
            color="var(--color-primary)"
            textColor="white"
            onClick={handleContinueClick}
          >
            Continue
          </DefaultButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};
